import * as React from "react";

import { makeStyles } from "@material-ui/core";

import { IColorRgb } from "../Model/IColorRgb";

interface IProps {
    readonly colors?: IColorRgb[];
}

const useStyles = makeStyles({
    containerStyle: {
        display: "flex",
        flexDirection: "row",
    
        width: "128px",
        height: "16px"
    },
    
    randomSwatchStyle: {
        flexGrow: 1,
        background: "repeating-conic-gradient(#808080 0% 25%, transparent 0% 50%) 50% / 10px 10px"
    },
});

export function ColorPalette(props: IProps): React.ReactElement {
    const classes = useStyles();

    if (props.colors === undefined) {
        return (
            <div className={classes.containerStyle}>
                <div className={classes.randomSwatchStyle} />
            </div>
        );
    }

    const lastIndex = props.colors.length - 1;

    const elements = props.colors.map((color, index) => {
        const style: React.CSSProperties = {
            flexGrow: 1,

            borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderLeft: "1px solid black",

            backgroundColor: `rgb(${color.r}, ${color.g}, ${color.b})`
        }

        if (index === lastIndex) {
            style.borderRight = "1px solid black";
        }

        return <div key={index} style={style} />;
    });

    return <div className={classes.containerStyle}>{elements}</div>;
}